module.exports = __webpack_public_path__ + "img/mb_hm_block03_02_en.e0bf8a9d.jpg";